import cx from "apps/website/utils/misc/cx";

import Sticker, { IStickerProps } from "../Sticker/Sticker";
import TextSubtitle from "../Text/TextSubtitle/TextSubtitle";
import TextBody from "../Text/TextBody/TextBody";

export interface StickerWithTextProps {
  sticker: IStickerProps;
  title?: string;
  description?: string;
}

export default function StickerWithText({
  sticker,
  title,
  description,
}: Readonly<StickerWithTextProps>) {
  return (
    <div className={cx("flex flex-col items-center gap-2")}>
      <Sticker {...sticker} />
      { title && (
        <TextSubtitle
          size={4}
          align={"center"}
          whitespace={"balance"}
          className="break-words max-w-full"
        >
          { title }
        </ TextSubtitle>
      ) }
      { description && (
        <TextBody
          size={3}
          align={"center"}
          whitespace={"balance"}
          className="break-words max-w-full"
        >
          { description }
        </TextBody>
      ) }
    </div>
  );
}
